(() => {
  const STATE = {
    inFlight: false,
    lastKey: null,
    sectionId: null,
    limit: 4,
  };

  function cartKey(cart) {
    const parts = (cart.items || []).map((i) => `${i.product_id}:${i.variant_id}:${i.quantity}`).join('|');
    return `${cart.item_count}::${parts}`;
  }

  function readMarker() {
    // marker should exist at least once on initial /cart render
    const marker = document.querySelector('[data-cart-complementary-marker]');
    if (!marker) return false;

    STATE.sectionId = marker.dataset.sectionId;
    STATE.limit = Number(marker.dataset.limit || 4);
    return !!STATE.sectionId;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  }

  async function fetchSectionHTML(productId) {
    const url =
      `/recommendations/products?product_id=${productId}` +
      `&intent=complementary` +
      `&limit=${STATE.limit}` +
      `&section_id=${encodeURIComponent(STATE.sectionId)}`;

    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return '';
    return res.text();
  }

  async function refreshSection() {
    if (STATE.inFlight) return;

    // If we lost the IDs (e.g. first run), read them
    if (!STATE.sectionId && !readMarker()) return;

    STATE.inFlight = true;
    try {
      const cart = await getCart();
      if (!cart) return;

      const key = cartKey(cart);
      if (STATE.lastKey === key) return;
      STATE.lastKey = key;

      const wrapper = document.getElementById(`shopify-section-${STATE.sectionId}`);
      if (!wrapper) return;

      // If cart empty => clear section
      if (!cart.items?.length) {
        wrapper.innerHTML = '';
        return;
      }

      // Use last cart item as context
      const productId = cart.items[cart.items.length - 1].product_id;

      const html = await fetchSectionHTML(productId);

      // If no complementary products => clear section
      if (!html.trim()) {
        wrapper.innerHTML = '';
        return;
      }

      // Replace whole section (Shopify returns full section markup)
      wrapper.outerHTML = html;

      // After replacement, the marker might be gone (because recommendations render mode doesn't include it),
      // but we already stored sectionId/limit in STATE, so we're fine.
    } finally {
      STATE.inFlight = false;
    }
  }

  // Initial load on /cart
  document.addEventListener('DOMContentLoaded', refreshSection);

  // If your theme emits these events (optional)
  document.addEventListener('cart:updated', refreshSection);
  document.addEventListener('cart:refresh', refreshSection);

  // Reliable fallback: whenever the theme calls /cart/change or /cart/update (remove/qty)
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && (url.includes('/cart/change') || url.includes('/cart/update'))) {
        // Let Dawn update DOM first
        setTimeout(refreshSection, 0);
      }
    } catch (_) {}
    return res;
  };
})();
